import { render, staticRenderFns } from "./NewDeliveryLocation.vue?vue&type=template&id=19c8cd59"
import script from "./NewDeliveryLocation.vue?vue&type=script&lang=js"
export * from "./NewDeliveryLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports